<template>
  <div :id="`reply_${reply.id}`" ref="targe" class="reply-item">
    <div class="avatar-profile" @click.stop="directReport(reply)">
      <img
        :src="reply.owner.avatarUrl"
        :onerror="isNightMode ? avatarDefaultDark : avatarDefault"
        class="avatar"
      >
    </div>

    <div class="reply">
      <div class="reply-top-info">
        <UserProfile :item-data="reply" :parent-owner="commentOwner" />

        <PraiseButton
          :comment-id="reply.commentId"
          :reply-id="reply.id"
          :thumbup-count="reply.thumbupCount"
          :is-thumb-up="reply.isThumbUp"
          :reply-content="reply.content"
          :comment-owner="reply.parentReply && reply.parentReply.owner"
          :reply-owner="reply.owner"
        />
      </div>
      <ContentBody
        type="reply"
        :data="reply"
        :comment-owner="commentOwner"
        @click="onReplyClick($event)"
        @update:dis-height="onChangeDisHeight"
      />

      <MenuBar :item-data="reply" />
    </div>
  </div>
</template>

<script lang="ts">
import GraphemeSplitter from 'grapheme-splitter';
import { toRefs, computed, defineComponent, ref, onMounted, onUnmounted } from 'vue';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';

// import { setTopicContent } from '../core/useTopicContent/index';
import { useOnCommentClickInject } from '../core/useOnCommentClickProvide/index';
import { commonCommentStat } from '../core/useStat';
import avatarDefault from '../assets/img/avatar_default.png';
import avatarDefaultDark from '../assets/img/avatar_default_dark.png';

import UserProfile from './UserProfile.vue';
import ContentBody from './ContentBody.vue';
import MenuBar from './MenuBar.vue';
import PraiseButton from './PraiseButton.vue';

export default defineComponent({
  name: 'ReplyItem',
  components: {
    UserProfile,
    ContentBody,
    MenuBar,
    PraiseButton,
  },
  props: {
    commentId: {
      type: String,
      required: true,
      default: '',
    },
    reply: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    commentOwner: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  emits: ['update:loadedReplySize', 'update:height', 'update:disHeight'],

  setup(props, { emit }) {
    const { onCommentClickThrottle } = useOnCommentClickInject();
    const { feature, isNightMode, userMeta } = toRefs(useGlobalState());

    const initMaxLength = 75;
    const splitter = new GraphemeSplitter();

    const targe = ref(null);

    const { reply } = toRefs(props);

    // 评论文本
    const body = computed(() => {
      return splitter.countGraphemes(reply.value.content) > initMaxLength
        ? `${splitter.splitGraphemes(reply.value.content).slice(0, initMaxLength).join('')}...`
        : reply.value.content;
    });

    const attachment = computed(() =>
      reply.value.imageList && reply.value.imageList.length > 0 ? '[动图]' : '',
    );

    const onDeleteReply = () => {
      // deleleReply(params)
      //   .then(() => {
      //     showToast('回复已删除!');
      //   })
      //   .catch((err) => {
      //     if (err.code === 1403) {
      //       // TODO(libiao)：重登录
      //       showToast('登陆效验未通过!');
      //     } else {
      //       showToast(`未知错误 ${err}`);
      //     }
      //   });
      const params = {
        commentId: reply.value.commentId || reply.value.id,
        replyId: reply.value.commentId ? reply.value.id : null,
        content: reply.value.content,
      };

      window.__commentSdkDelComment(params).then((res) => {
        const { code } = res;

        if (code === 0) {
          // emit
          emit('update:loadedReplySize');
        }
      });
    };

    const onReplyClick = (event) => {
      // if (feature.value.enableSecondCommentDetail) {
      // 冒泡至祖先层元素事件处理
      // } else {
      onCommentClickThrottle(reply.value, {
        directComment: true,
      });
      event.stopPropagation();
      // }
    };

    const directReport = (reply) => {
      commonCommentStat(20084690, {
        userId: reply.owner.id,
      });

      if (userMeta.value.uid === reply.owner.id) {
        return;
      }

      onCommentClickThrottle(reply, {
        directReport: true,
      });
    };

    // nextTick(() => {
    //   setTopicContent(reply.value);
    // });

    onMounted(() => {
      emit('update:height', targe.value.offsetHeight);
    });

    onUnmounted(() => {
      emit('update:height', 0);
    });

    const onChangeDisHeight = (disHeight: number) => {
      emit('update:disHeight', disHeight);
    };

    return {
      isNightMode,

      body,
      attachment,
      avatarDefault,
      avatarDefaultDark,

      targe,

      onReplyClick,
      onDeleteReply,
      directReport,

      enableSecondCommentDetail: feature.value.enableSecondCommentDetail,

      onChangeDisHeight,
    };
  },
});
</script>

<style scoped lang="scss">
@import '../assets/css/styling-mixin.scss';

.reply-item {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
}

// .reply-item:not(:last-child) {
.reply-item {
  padding: 24px 48px 0 186px;
}

.reply-item:not(:first-child) {
  margin-top: 0;
}

.reply-detail,
.reply-tip {
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  font-weight: normal;
  font-size: 42px;
  letter-spacing: 0;
  line-height: 60px;
}

:deep(.topic-tag) {
  color: rgba(38, 96, 245, 1);
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

.reply-tip {
  font-weight: 500;
  color: rgba($color: #000, $alpha: 0.55);
}

.reply-username {
  font-weight: 500;
  font-size: 42px;
}

.reply-remove {
  float: right;
  height: 57px;
  padding-top: 6px;
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  font-size: 36px;
  color: #494949;
  line-height: 57px;
}

.avatar-profile {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 66px;
  position: relative;
  &:active {
    transform: scale(0.8);
    transition: all 0.3s ease;
  }

  @include setRounded1pxBorder(rgba(0, 0, 0, 0.1), before, 72px);

  .avatar {
    width: 72px;
    height: 72px;
    border-radius: 66px;
    margin-top: 0;
    vertical-align: top;
  }
}

.reply {
  margin-left: 24px;
  flex: 1;
  font-size: 36px;
  font-family: ColorFont-Regular, 'OPlusSans 3.0';
  min-width: 0; // fix flex & ellipsis

  .reply-top-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    padding: 12px 0;
  }
}

.reply-bar {
  display: flex;
  align-items: center;
  line-height: 48px;
}

.time {
  font-weight: 400;
  color: rgba($color: #000, $alpha: 0.26);
  margin: 12px 0;
  @include os-browser-styling('', '', false, false, true) {
    color: rgba($color: #fff, $alpha: 0.3);
  }
}

.place {
  color: rgba($color: #000, $alpha: 0.26);
  &::before {
    content: '·';
    margin: 0 6px;
  }
}

html[data-theme='dark'] {
  .reply-username {
    color: rgba(255, 255, 255, 0.7);
  }
  .reply-tip {
    color: rgba(255, 255, 255, 0.7);
  }
}
</style>
